import { render, staticRenderFns } from "./CustomerSourceSettings.vue?vue&type=template&id=b8da12a0&scoped=true&"
import script from "./CustomerSourceSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerSourceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8da12a0",
  null
  
)

export default component.exports